import React from "react";
import { Facebook, Instagram, Youtube } from "lucide-react";
import Logo from "../../assets/logo.png";
import SectionBreak from "./SectionBreak";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
    <SectionBreak />
    <footer className="w-full bg-black text-white border-t border-[#333333] pb-5">
      <div className="container mx-auto px-4 pt-10">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 mb-8">
          <div className="flex flex-col">
            <div className="text-2xl font-bold mb-4">
              <img
                src={Logo}
                alt="Logo"
                className="w-24 h-20 object-contain"
              />
            </div>

            {/* Main navigation */}
            <nav className="flex flex-wrap gap-x-6 gap-y-2 mt-4">
              <a href="#" className="text-white hover:text-gray-300">Startseite</a>
              <a href="#car-search-section" className="text-white hover:text-gray-300">Unsere Fahrzeuge</a>
              <a href="#about" className="text-white hover:text-gray-300">Über uns</a>
              <a href="#contact" className="text-white hover:text-gray-300">Kontaktieren Sie uns</a>
            </nav>
          </div>

          {/* Newsletter and social section */}
          {/* <div className="flex flex-col">
            <div className="mb-4">
              <p className="mb-2">Abonnieren Sie unseren Newsletter</p>
              <div className="flex gap-2">
                <input
                  type="email"
                  placeholder="Email address"
                  className="h-10  bg-white px-3 py-2 text-sm text-black border-0 focus:outline-none w-full max-w-xs rounded-[25px]"
                />
                <button
                  type="submit"
                  className="rounded-[25px]  border border-[#333333] px-4 py-2 text-sm font-medium text-white"
                >
                  Abonnieren
                </button>
              </div>
            </div>
          </div> */}
        </div>

        <div className="border-t border-zinc-800 pt-6 flex flex-col md:flex-row justify-between items-center">
          <div className="flex gap-6 text-sm text-gray-400">
            <Link to="/impressum" className="hover:text-white">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-white">Datenschutz</Link>
          </div>

          <div className="flex gap-4 mt-4 md:mt-0">
            {/* <a href="#" className="text-white hover:text-gray-300">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#D3D3D3" />
                <path d="M24.8203 21.75H21.8906V30.5H17.9844V21.75H14.7812V18.1562H17.9844V15.3828C17.9844 12.2578 19.8594 10.5 22.7109 10.5C24.0781 10.5 25.5234 10.7734 25.5234 10.7734V13.8594H23.9219C22.3594 13.8594 21.8906 14.7969 21.8906 15.8125V18.1562H25.3672L24.8203 21.75Z" fill="#D3D3D3" />
              </svg>

            </a> */}
            <a href="https://www.instagram.com/bustosautomobile.ch" className="text-white hover:text-gray-300">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#D3D3D3" />
                <path d="M20.1516 16.0078C22.6125 16.0078 24.6438 18.0391 24.6438 20.5C24.6438 23 22.6125 24.9922 20.1516 24.9922C17.6516 24.9922 15.6594 23 15.6594 20.5C15.6594 18.0391 17.6516 16.0078 20.1516 16.0078ZM20.1516 23.4297C21.7531 23.4297 23.0422 22.1406 23.0422 20.5C23.0422 18.8984 21.7531 17.6094 20.1516 17.6094C18.5109 17.6094 17.2219 18.8984 17.2219 20.5C17.2219 22.1406 18.55 23.4297 20.1516 23.4297ZM25.8547 15.8516C25.8547 16.4375 25.3859 16.9062 24.8 16.9062C24.2141 16.9062 23.7453 16.4375 23.7453 15.8516C23.7453 15.2656 24.2141 14.7969 24.8 14.7969C25.3859 14.7969 25.8547 15.2656 25.8547 15.8516ZM28.8234 16.9062C28.9016 18.3516 28.9016 22.6875 28.8234 24.1328C28.7453 25.5391 28.4328 26.75 27.4172 27.8047C26.4016 28.8203 25.1516 29.1328 23.7453 29.2109C22.3 29.2891 17.9641 29.2891 16.5188 29.2109C15.1125 29.1328 13.9016 28.8203 12.8469 27.8047C11.8313 26.75 11.5188 25.5391 11.4406 24.1328C11.3625 22.6875 11.3625 18.3516 11.4406 16.9062C11.5188 15.5 11.8313 14.25 12.8469 13.2344C13.9016 12.2188 15.1125 11.9062 16.5188 11.8281C17.9641 11.75 22.3 11.75 23.7453 11.8281C25.1516 11.9062 26.4016 12.2188 27.4172 13.2344C28.4328 14.25 28.7453 15.5 28.8234 16.9062ZM26.9484 25.6562C27.4172 24.5234 27.3 21.7891 27.3 20.5C27.3 19.25 27.4172 16.5156 26.9484 15.3438C26.6359 14.6016 26.05 13.9766 25.3078 13.7031C24.1359 13.2344 21.4016 13.3516 20.1516 13.3516C18.8625 13.3516 16.1281 13.2344 14.9953 13.7031C14.2141 14.0156 13.6281 14.6016 13.3156 15.3438C12.8469 16.5156 12.9641 19.25 12.9641 20.5C12.9641 21.7891 12.8469 24.5234 13.3156 25.6562C13.6281 26.4375 14.2141 27.0234 14.9953 27.3359C16.1281 27.8047 18.8625 27.6875 20.1516 27.6875C21.4016 27.6875 24.1359 27.8047 25.3078 27.3359C26.05 27.0234 26.675 26.4375 26.9484 25.6562Z" fill="#D3D3D3" />
              </svg>

            </a>
            {/* <a href="#" className="text-white hover:text-gray-300">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#D3D3D3" />
                <path d="M30.3625 15.3828C30.8313 17.0234 30.8313 20.5391 30.8313 20.5391C30.8313 20.5391 30.8313 24.0156 30.3625 25.6953C30.1281 26.6328 29.3859 27.3359 28.4875 27.5703C26.8078 28 20.1672 28 20.1672 28C20.1672 28 13.4875 28 11.8078 27.5703C10.9094 27.3359 10.1672 26.6328 9.93281 25.6953C9.46406 24.0156 9.46406 20.5391 9.46406 20.5391C9.46406 20.5391 9.46406 17.0234 9.93281 15.3828C10.1672 14.4453 10.9094 13.7031 11.8078 13.4688C13.4875 13 20.1672 13 20.1672 13C20.1672 13 26.8078 13 28.4875 13.4688C29.3859 13.7031 30.1281 14.4453 30.3625 15.3828ZM17.9797 23.7031L23.5266 20.5391L17.9797 17.375V23.7031Z" fill="#D3D3D3" />
              </svg>

            </a> */}
          </div>
        </div>
      </div>
    </footer>
    </>
  );
};

export default Footer;